// extracted by mini-css-extract-plugin
export default {"root":"ProfitCentresView_root__9oYah","panel":"ProfitCentresView_panel__Rs5jb","content":"ProfitCentresView_content__v1Wy6"};